export default __webpack_public_path__ + "static/hero-mockup-dark-5310ebcbb31b2c63fef99b2ddcdc7070.png";